import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/pages/home/home.vue'),
      meta: {
        index: 0,
        title: '微财-创新金融服务,创造美好生活'
      }
    },
    {
      path: '/WeTechnology',
      name: 'WeTechnology',
      component: () => import('@/pages/weTech/index.vue'),
      meta: {
        index: 1,
        title: '微财-创新金融服务,创造美好生活'
      }
    },
    {
      path: '/WeProduct',
      name: 'WeProduct',
      component: () => import('@/pages/weProduct'),
      meta: {
        index: 2,
        title: '好分期-微财旗下分期借款平台'
      }
    },
    {
      path: '/WeCulture',
      name: 'WeCulture',
      component: () => import('@/pages/weCulture'),
      meta: {
        index: 3,
        title: '企业文化-微财'
      }
    },
    {
      path: '/WeAbout',
      name: 'WeAbout',
      component: () => import('@/pages/aboutWe/aboutWe.vue'),
      meta: {
        index: 4,
        title: '关于我们-微财'
      }
    },
    {
      path: '/WeNewsDetail',
      name: 'WeNewsDetail',
      component: () => import('@/pages/weNewsDetail'),
      meta: {
        index: 5,
        title: '关于我们-微财'
      }
    },
    {
      path: '/responsibility',
      name: 'responsibility',
      component: () => import('@/pages/responsibility/index.vue'),
      meta: {
        index: 6,
        title: '社会责任-微财'
      }
    },
    {
      path: '*',
      name: 'Home',
      component: () => import('@/pages/home/home.vue'),
      meta: {
        index: 0,
        title: '微财-创新金融服务,创造美好生活'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js